<!--
 * @Author       : 赵子强
 * @Date         : 2024-05-08 11:20:50
 * @LastEditTime : 2024-05-09 11:28:16
 * @LastEditors  : 赵子强
 * @Description  : 说明
-->
<template>
  <div ref="paint" :class="'keyboard-paint keyboard-paint__'+size" style="margin-top:5px;">
    <div :style="{width:p_width*0.4+'px',height:p_height+'px'}" class="canvas-box">
      <div class="drawingBoard loading"><span>Loading...</span></div>
    </div>
    <div :style="{width:p_width*0.3+'px',height:p_height+'px'}" class="result_div">
      <span v-for="(item, index) in write_result" :key="index" class="" @click="Select(item)" >
        {{item}}
      </span>
    </div>
    
  </div>
</template>

<script>
import mmah from './dist/mmah'
import orig from './dist/orig'
import HanziLookup from './hanzilookup.min.js'
export default {
  name: '',
  components:{},
  props: {
    size:String,
    p_width: [String, Number],
    p_height: [String, Number],
  },
  data(){
    return {
      mmahData:'',
      origData:'',
      _filesToLoad:'',
      _drawingBoard:'',
      write_result:[]
    }
  },
  created(){},
  mounted(){
    this._filesToLoad = 2;
    const mmahData = JSON.parse(JSON.stringify(mmah))
    const origData = JSON.parse(JSON.stringify(orig))
    this.mmahData = mmahData
    this.origData = origData
    // 这里值会变化 没有改 需要调整
    HanziLookup.init("mmah", this.mmahData, this.fileLoaded);
    HanziLookup.init("orig", this.origData, this.fileLoaded);
    this.write_result = []
  },
  computed:{},
  methods:{
    UpdateBound() {},
    fileLoaded(success) {
      if (!success) {
        this._filesToLoad = -1;
        $(".drawingBoard span").text("Failed to load data.");
        return;
      }

      --this._filesToLoad;
      if (this._filesToLoad != 0) return;
      $(".drawingBoard").removeClass("loading");

      this._drawingBoard = HanziLookup.DrawingBoard($(".drawingBoard").first(), this.lookup,this.p_width*0.4,this.p_height);
    },
    lookup() {
      const that = this
      var analyzedChar = new HanziLookup.AnalyzedCharacter(this._drawingBoard.cloneStrokes());
      // Look up with original HanziLookup data
      var matcherOrig = new HanziLookup.Matcher("orig");
      matcherOrig.match(analyzedChar, 8, function(matches) {
        // that.showResults($(".hanziLookupChars"), matches);
      });
      // Look up with MMAH data
      var matcherMMAH = new HanziLookup.Matcher("mmah");
      matcherMMAH.match(analyzedChar, 8, function(matches) {
        // that.showResults($(".mmahLookupChars"), matches);
        that.GetText(matches)
      });
    },
    // 提取文字
    GetText(matches) {
      const that = this
      that.write_result = []
      for (var i = 0; i != matches.length; ++i) {
        that.write_result.push(matches[i].character)
      }
    },
    //选择文字
    Select(text) {
      this.$emit("SelectText", text);
      this.write_result = [];
      this.Reload();
    },
    // 画布清除
    Reload() {
      this._drawingBoard.clearCanvas();
      this._drawingBoard.redraw();
      this.lookup();
    },
    cmdUndo() {
      this._drawingBoard.undoStroke();
      this._drawingBoard.redraw();
      this.lookup();
    }
    // showResults(elmHost, matches) {
    //   elmHost.html("");
    //   for (var i = 0; i != matches.length; ++i) {
    //     elmHost.append("<span>" + matches[i].character + "</span>");
    //   }
    // }
  },
  watch:{},
}
</script>
<style lang="scss">
.keyboard-paint {
  display: inline-block;
  vertical-align: middle;
  .canvas-box {
    display: inline-block;
    vertical-align: middle;
    background: #fff;
    font-size: 0px;
    #canvas {
      border: 1px solid #aaa;
    }
  }
}
.drawingBoard { width: 100%; height: 100%; cursor: crosshair; clear: both; overflow: hidden; background-color: #fafafa; }
.drawingBoard span { display: none; }
.drawingBoard.loading { background-color: #f0f0f0; }
.drawingBoard.loading span { display: inline; color: #606060; }



.result_div {
  display: inline-block;
  vertical-align: middle;
  margin-left: 8px;
  background: #fff;
  span {
      display: inline-block;
      border: 1px solid #aaa;
      width: 50%;
      height: 90px;
      font-size: 40px;
      font-weight: bold;
      background: #fff;
      font-family: simsun;
      text-align: center;
      line-height: 90px;
      box-sizing: border-box;
      &:active {
        background: #aaa;
      }
  }
}
</style>